import { useMemo } from 'react';

import {
  SidebarSection,
  useDisplayNames,
} from '@spotify/confidence-core-react';
import { MeasurementConfig } from '@spotify/plugin-confidence-metrics-react';

import { MeasurementInput, QueryPreviewCard } from '../SimplifiedQuery';

type PreviewSectionValue = MeasurementInput & {
  entity?: string | null;
  factTable?: string | null;
  metricWindow?: MeasurementConfig;
};

type PreviewSectionProps = {
  value: PreviewSectionValue;
};

export const PreviewSection = ({ value }: PreviewSectionProps) => {
  const { displayNames } = useDisplayNames();

  const measurement = useMemo<MeasurementInput>(
    () => ({
      typeSpec: value.typeSpec,
      nullHandling: value.nullHandling,
      filter: value.filter,
    }),
    [value.typeSpec, value.nullHandling, value.filter],
  );

  return (
    <SidebarSection.Root>
      <SidebarSection.Header>
        <SidebarSection.Title>Preview</SidebarSection.Title>
      </SidebarSection.Header>
      <SidebarSection.Content>
        <QueryPreviewCard
          entity={displayNames.get(value.entity ?? '')}
          factTable={displayNames.get(value.factTable ?? '')}
          measurement={measurement}
          metricWindow={value.metricWindow}
        />
      </SidebarSection.Content>
    </SidebarSection.Root>
  );
};
